import { ref, readonly } from 'vue';
import { post, ENDPOINTS } from '@/api/mainApi';
import { BASE_URL, MainApi } from '@/api/mainApi';
import store from '@/store';

export interface CertificateData {
  // Define the certificate data interface based on usage
  [key: string]: any;
}

export function useCertificateOperations() {
  const loading = ref(false);
  const error = ref<string | null>(null);

  const generateCertificate = async (certificateData: CertificateData): Promise<any> => {
    loading.value = true;
    error.value = null;

    try {
      const result = await post(`${ENDPOINTS.DONATIONS}/${ENDPOINTS.CERTIFICATE}`, certificateData);
      return result;
    } catch (err) {
      error.value = 'Failed to generate certificate';
      store.commit('setSnackbar', { active: true, color: 'error', text: error.value });
      throw err;
    } finally {
      loading.value = false;
    }
  };

  const getCertificateUrl = (serialNumber: string, asImage: boolean = true): string => {
    const params = asImage ? '?asImage=true' : '';
    return `${BASE_URL}/${MainApi}/${ENDPOINTS.DONATIONS}/${serialNumber}/${ENDPOINTS.CERTIFICATE}${params}`;
  };

  /** PDF with full-resolution artwork — use for print/download, not screen preview. */
  const getCertificatePrintUrl = (serialNumber: string): string => {
    return `${BASE_URL}/${MainApi}/${ENDPOINTS.DONATIONS}/${serialNumber}/${ENDPOINTS.CERTIFICATE}?includeAddress=false&log=true`;
  };

  return {
    loading: readonly(loading),
    error: readonly(error),
    generateCertificate,
    getCertificateUrl,
    getCertificatePrintUrl,
  };
}
